import React from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { useWebsiteConfig } from "../../hooks/useData";

const SEO = ({
  title,
  description,
  keywords,
  image,
  type = "website",
  url,
  children,
}) => {
  const website = useWebsiteConfig();
  const { pathname } = useLocation();

  // Ensure image is absolute URL
  const siteUrl = "https://www.muskansoftwares.com";
  const defaultImage = `${siteUrl}/og-image-v2.jpg`;

  // Computed Values
  const seoTitle = title
    ? `${title} | ${website.name}`
    : `${website.name} - ${website.tagline}`;
  const seoDescription = description || website.description;
  const seoUrl = url || `${siteUrl}${pathname}`;
  const seoKeywords =
    keywords ||
    "virtual software house pakistan, software house pakistan, custom software development, web development company";

  let seoImage = image || defaultImage;
  if (!seoImage.startsWith("http")) {
    seoImage = `${siteUrl}${seoImage}`;
  }

  return (
    <Helmet>
      {/* Standard Metadata */}
      <title>{seoTitle}</title>
      <meta name="description" content={seoDescription} />
      <meta name="keywords" content={seoKeywords} />
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={seoUrl} />
      <meta property="og:title" content={seoTitle} />
      <meta property="og:description" content={seoDescription} />
      <meta property="og:image" content={seoImage} />
      <meta property="og:site_name" content={website.name} />
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:creator" content="@MuskanSoftwares" />
      <meta name="twitter:title" content={seoTitle} />
      <meta name="twitter:description" content={seoDescription} />
      <meta name="twitter:image" content={seoImage} />
      {children}
    </Helmet>
  );
};

export default SEO;
